module.exports = __webpack_public_path__ + "img/thumb-005-19.ffe36ef4.png";